const AUTH_URL =
  `https://accounts.spotify.com/authorize?client_id=971b948ffd3645aca27b3708306cb672&response_type=code&redirect_uri=${window.location.origin}&scope=streaming%20user-read-email%20user-read-private%20user-library-read%20user-library-modify%20user-read-playback-state%20user-modify-playback-state%20playlist-modify-public%20playlist-read-private%20playlist-read-collaborative%20playlist-modify-private`

export const Login = () => {

  return (<>
    <div className="login">
      <div className="login-header" >
        <img src='assets/cosmox-bubble.png' alt='Avatar'/>
      </div>
      <h1>Connexion</h1>
      <div className='login-apps'>
        <a  href={AUTH_URL} className='login-apps__spotify'>
          <svg>
            <use xlinkHref='#icon-spotify'/>
          </svg>
        </a>
        <a className='login-apps__deezer' href='/'>
          <svg>
            <use xlinkHref='#icon-deezer'/>
          </svg>
        </a>
        <a className='login-apps__apple' href='/'><svg>
            <use xlinkHref='#icon-apple-music'/>
          </svg></a>
        <a className='login-apps__youtube' href='/'><svg>
            <use xlinkHref='#icon-youtube'/>
          </svg></a>
      </div>
      <p>
        Connectez vous avec votre application 
        d’écoute.Cosmox récupéreras vos habitudes 
        d’écoute  pour affiner votre découverte
      </p>
      <div className='blur1'></div>
      <div className='blur2'></div>
      <div className='blur3'></div>
    </div>
  </>)
}

